import { FC } from 'react';
import { ClientWithoutEmailDialogProps } from './ClientWithoutEmailDialog.types';
import { Alert, Button, ButtonGroup, Dialog, Flex } from '@/_components';

export const ClientWithoutEmailDialog: FC<ClientWithoutEmailDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Blank Email Confirmation">
      <Dialog.Content>
        <Flex isColumn={true} gap={8}>
          <Alert type="info" icon="info">
            Users without email addresses will not be able to sign in or receive
            notifications. Do you want to proceed?
          </Alert>
          <ButtonGroup align="right">
            <Button intent="secondary" onClick={onClose} value="Add email" />
            <Button intent="primary" onClick={onConfirm} value="Confirm" />
          </ButtonGroup>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
};
